import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTachometerAlt,
  FaRocket,
  FaMobileAlt,
  FaShoppingCart,
  FaShieldAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const FastLoadingEcommerceWebsitesInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Fast-Loading E-commerce Websites in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Speed Meets Success</Subheading>}
        heading={
          <Heading>
            Fast-Loading <span tw="text-primary-500">E-commerce Websites</span>{" "}
            in Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in building fast-loading e-commerce
            websites in **Bur Dubai**, ensuring your customers enjoy seamless
            shopping experiences while boosting your conversions. Speed up your
            success with a high-performance online store.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1580894908361-967195033215?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1601972599748-19fe5a7e756f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Speed Up Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Fast-Loading E-commerce Solutions in Bur Dubai"
        description="We prioritize speed to enhance user experience and sales."
        cards={[
          {
            icon: <FaTachometerAlt color="#ff5464" size={40} />,
            title: "Lightning Speed",
            description: "Optimized for load times under 2 seconds.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Performance Boost",
            description: "Improved SEO and conversion rates with speed.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimization",
            description: "Fast performance on all devices, especially mobiles.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Higher Sales",
            description: "Reduce bounce rates and increase purchases.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure & Stable",
            description: "Speed without compromising security.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven results for Bur Dubai businesses.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Process for Fast-Loading E-commerce Sites"
        description={
          <Description>
            We deliver speed-optimized e-commerce websites with a streamlined
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Analysis: Assess your current site speed and needs.</li>
              <li>Design: Create lightweight, efficient layouts.</li>
              <li>Development: Use cutting-edge tech for fast performance.</li>
              <li>
                Optimization: Minimize code, images, and server response times.
              </li>
              <li>Testing: Verify speed across devices and networks.</li>
              <li>Support: Maintain peak performance post-launch.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1534120247760-c44c3e4a62f1?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Speed-Driven Success in Bur Dubai"
        description="Our fast-loading websites have transformed e-commerce results."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Speed Boost",
            description: "Reduced load time by 70% for a local retailer.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Surge",
            description: "Increased conversions by 150% with faster pages.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Feedback",
            description: "98% satisfaction from speed-focused projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for a Faster Store?</Subheading>}
        heading="Fast-Loading E-commerce in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset to create a fast-loading e-commerce
            website in Bur Dubai that keeps customers engaged and boosts your
            bottom line. Let’s accelerate your success today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1564069114553-7215e1ff1890?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1574717024453-354056adc482?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
